module.exports = __webpack_public_path__ + "img/2.ff6d6078.png";